import { render, staticRenderFns } from "./widget-cascader.vue?vue&type=template&id=8c249a1a"
import script from "./widget-cascader.vue?vue&type=script&lang=js"
export * from "./widget-cascader.vue?vue&type=script&lang=js"
import style0 from "./widget-cascader.vue?vue&type=style&index=0&id=8c249a1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports